/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class ChatmessagesFileDialog extends NoboxEntityDialog<ChatroomsRow, any> {
        protected getFormKey() { return ChatmessagessFileForm.formKey; }
        protected getIdProperty() { return ChatmessagesRow.idProperty; }
        protected getLocalTextPrefix() { return ChatmessagesRow.localTextPrefix; }
        protected getNameProperty() { return ChatmessagesRow.nameProperty; }
        protected getService() { return ChatmessagesService.baseUrl; }
        protected getDeletePermission() { return ChatmessagesRow.deletePermission; }
        protected getInsertPermission() { return ChatmessagesRow.insertPermission; }
        protected getUpdatePermission() { return ChatmessagesRow.updatePermission; }

        protected form = new ChatmessagessFileForm(this.idPrefix);
        public isFile: string;
        public callback = (a, b, c, d) => {

        }
        constructor(container?: JQuery) {
            super(container);
            var $this = this;
            setTimeout(function () {
                if ($this.isFile == "File") {
                    $this.dialogTitle = "Send Quick Reply";
                } else {
                    $this.dialogTitle = "Select Files";
                }
            }, 0)
            this.element.find(".s-DialogToolbar").height(0);
            $('<a class="inplace-button inplace-action3"><b><i class="fa fa-paper-plane text-primary"></i></b></a>')
                .attr("title", "Send a files message")
                .insertAfter(this.form.Msg.element)
                .click(e => {
                    if (this.validateForm()) {
                        var initFile = [];
                        if (this.isFile == "File") {
                            this.form.File.value.forEach(function (e) {
                                if (e.Filename.includes(".mp4")) {
                                    initFile.push('vid')
                                } else if (e.Filename.includes(".mkv")) {
                                    initFile.push('vid')
                                } else if (e.Filename.includes(".gif")) {
                                    initFile.push('vid')
                                } else if (e.Filename.includes(".avi")) {
                                    initFile.push('vid')
                                } else if (e.Filename.includes(".3gp")) {
                                    initFile.push('vid')
                                } else if (e.Filename.includes(".mp3")) {
                                    initFile.push('aud')
                                } else {
                                    initFile.push('file')
                                }
                            });
                        } else {
                            this.form.Files.value.forEach(function (e) {
                                if (e.Filename.includes(".mp4")) {
                                    initFile.push('vid')
                                } else if (e.Filename.includes(".mkv")) {
                                    initFile.push('vid')
                                } else if (e.Filename.includes(".gif")) {
                                    initFile.push('vid')
                                } else if (e.Filename.includes(".avi")) {
                                    initFile.push('vid')
                                } else if (e.Filename.includes(".3gp")) {
                                    initFile.push('vid')
                                } else if (e.Filename.includes(".mp3")) {
                                    initFile.push('aud')
                                } else {
                                    initFile.push('file')
                                }
                            });
                        }
                        if (initFile.every((val, i, arr) => val === arr[0] && arr[0] == "vid")) {
                            this.form.Type.value = '4';
                        } else if (initFile.every((val, i, arr) => val === arr[0] && arr[0] == "aud")) {
                            this.form.Type.value = '2';
                        } else {
                            this.form.Type.value = '5';
                        }
                        this.form.Ack.value = 2;
                        this.callback(this.form.Msg.value, JSON.stringify(this.form.Files.value), JSON.stringify(this.form.File.value), this.form.Type.value);
                        this.dialogClose()
                    }
                });
            var initFile = false;
            this.form.File.element.parent().find("ul").on("DOMNodeInserted", function () {
                if (initFile == false) {
                    initFile = true;
                    $('ul li.file-item.file-image').each(function () {
                        var elIMage = $(this).find(".thumb ");
                        $(this).find(".thumb ").removeAttr("style");
                        $(this).find(".thumb ").css("overflow", "hidden");
                        var image = elIMage.attr("href");
                        elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                    });
                    initFile = false;
                }
            });
            var initFiles = false;
            this.form.Files.element.parent().find("ul").on("DOMNodeInserted", function () {
                if (initFiles == false) {
                    initFiles = true;
                    $('ul li.file-item.file-image').each(function () {
                        var elIMage = $(this).find(".thumb ");
                        $(this).find(".thumb ").removeAttr("style");
                        $(this).find(".thumb ").css("overflow", "hidden");
                        var image = elIMage.attr("href");
                        elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                    });
                    initFiles = false;
                }
            });
        }
        protected updateInterface() {
            super.updateInterface();
            var $this = this;
            if (this.isFile) {
                $this.form.File.getGridField().toggle(true);
                $this.form.Files.getGridField().toggle(false);
            } else {
                $this.form.File.getGridField().toggle(false);
                $this.form.Files.getGridField().toggle(true);
            }
            //this.form.Msg.element.keyup(function (e) {
            //    if (e.keyCode == 13) {
            //        $(".send-file").click();
            //    }
            //})
        }
        dialogOpen() {
            super.dialogOpen();
            if (this.isFile == "File") {
                $(".s-ChatmessagesFileDialog").children("div.ui-dialog-titlebar").find("span.ui-dialog-title").text("Send Quick Reply");
            }
        }

        protected getToolbarButtons() {
            return [];
        }
    }
}